import React, { useState } from "react";
import styles from "./Header.module.css";
import Logo from "../../Assets/Logo.png";

export default function Header() {
  const [open, setOpen] = useState(false);

  const handleNavClick = () => {
    setOpen(false);
  };

  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <img
          src={Logo}
          alt="MB Sistemas"
          className={styles.logo}
        />

        <div
          className={styles.menuToggle}
          onClick={() => setOpen(!open)}
        >
          {open ? "✕" : "☰"}
        </div>

        <nav className={`${styles.nav} ${open ? styles.active : ""}`}>
          <a href="#produtos" onClick={handleNavClick}>Produtos</a>
          <a href="#diferenciais" onClick={handleNavClick}>Diferenciais</a>
          <a href="#contato" onClick={handleNavClick}>Contato</a>
          <a
            href="https://wa.me/5517991254844?text=Ol%C3%A1,%20vim%20pelo%20site%20e%20quero%20conhecer%20o%20MBControl"
            target="_blank"
            rel="noreferrer"
            className={styles.cta}
            onClick={handleNavClick}
          >
            Fale Conosco
          </a>
        </nav>
      </div>
    </header>
  );
}
